"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSDKUserFromCredentials = exports.isSDKUserToken = void 0;
const jwt_token_1 = require("./jwt_token");
const toolbox_1 = require("@streem/toolbox");
const api_1 = require("@streem/api");
const logger_1 = require("./logger");
function isSDKUserToken(token) {
    const data = (0, jwt_token_1.parseJwtToken)(token);
    // embedded sso tokens have streem:api in the issuer field
    return !!data.iss && data.iss.indexOf('streem:api:') === 0;
}
exports.isSDKUserToken = isSDKUserToken;
function getSDKUserFromCredentials(credentials, companyCode) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { authIdentity } = yield api_1.StreemAPI.auth.getCurrentAuthIdentity();
            (0, toolbox_1.invariant)(authIdentity === null || authIdentity === void 0 ? void 0 : authIdentity.user, 'Expected current AuthIdentity to be a User');
            // For now we assume that if the user does not have a Group Reservation then they must be an ExpertUser. That is
            // not a great assumption to make in general. But at the moment our web code does not implement any flows that
            // would allow a non-expert user to login with an SDK Token that does not include a Group Reservation.
            if (authIdentity.user.groupReservation) {
                return {
                    id: credentials.streem_user_id,
                    companyId: credentials.streem_company_id,
                    exp: credentials.expires_in,
                    groupReservation: authIdentity.user.groupReservation,
                };
            }
            else {
                const user = authIdentity.user.user;
                (0, toolbox_1.invariant)(user, "Received successful GetCurrentAuthIdentity without a 'user.user'");
                return {
                    id: credentials.streem_user_id,
                    scope: credentials.scope,
                    companyCode,
                    email: user.email,
                    name: user.name,
                    avatarUrl: user.avatarUrl,
                };
            }
        }
        catch (error) {
            logger_1.logger.error({
                msg: 'Error getting current user',
                userId: credentials.streem_user_id,
                error: error,
            });
            throw error;
        }
    });
}
exports.getSDKUserFromCredentials = getSDKUserFromCredentials;
//# sourceMappingURL=sdk_user.js.map